export const NOT_AUTHENTICATED_ROUTE_NAME = "auth";
export const AUTHENTICATED_ROUTE_NAME = "/";
export const AUTHENTICATED_ROUTE_NAME_CHECK = "/check";

export const LOGIN_ROUTE_PATH = `/${NOT_AUTHENTICATED_ROUTE_NAME}/login`;
export const LOGIN_OTP_ROUTE_PATH = `/${NOT_AUTHENTICATED_ROUTE_NAME}/login/otp`;
export const REGISTER_ROUTE_PATH = `/${NOT_AUTHENTICATED_ROUTE_NAME}/register`;
export const REGISTER_RESTAURANT_ROUTE_PATH = `/${NOT_AUTHENTICATED_ROUTE_NAME}/register/restaurant`;
export const REGISTER_RESTAURANT_DETAILS_ROUTE_PATH = `/${NOT_AUTHENTICATED_ROUTE_NAME}/add/register/restaurant`;
export const REGISTER_RESTAURANT_LOGO_ROUTE_PATH = `/${NOT_AUTHENTICATED_ROUTE_NAME}/register/restaurant/logo`;
export const ADD_NEW_RESTAURANT_MIGRATION_PATH = `/add/newrestaurant/migration`;
export const MENU_ROUTE_PATH = `/menu/menus`;

export const CHECK_LIST_ROUTE_PATH = `/loading`;

export const PAYMENT_BASE_ROUTE_PATH = "payment";
export const PAYMENT_PLAN_ROUTE_PATH = `/${PAYMENT_BASE_ROUTE_PATH}/plan`;

export const ADD_RESTAURANT_ROUTE_PATH = `/check/add/restaurant`;
export const ADD_RESTAURANT_LOGO_ROUTE_PATH = `/check/add/restaurant/logo`;